<template>
  <!-- 内容管理-产品详情 -->
  <div>
    <Form ref="form" :model="formData" class="page-form" label-position="top" @submit.native.prevent>
      <div class="info-text">
        <Icon type="ios-alert-outline" />
        如需在展业APP点击产品进入详情页，请填写详情页头图、并至少选择产品详情图与产品保障责任中的一项进行填写。
      </div>
      <FormItem class="upload-item full banner" label="详情页头图" prop="headImg">
        <template #label>
          <span>详情页头图</span>
          <Poptip trigger="hover" placement="right-start" transfer>
            <template #content>
              <img class="example-img m" src="@static/images/product/ex01.jpg"/>
            </template>
            <Icon type="ios-help-circle-outline" />
          </Poptip>
        </template>
        <upLoad :arr="formData.headImg" @upload="file => upLoadImg(file, 'headImg')" tip="注：尺寸750*362px"> </upLoad>
        <Button type="primary" @click="bannerCover" ghost>选择底图生成头图</Button>
        <Button type="primary" @click="getBanner('headImg')" ghost>随机生成头图</Button>
      </FormItem>
      <FormItem class="upload-item full" label="列表封面图" prop="mobileCover" :rules="$units.formRule.required('请上传列表封面图')">
        <template #label>
          <span>列表封面图</span>
          <Poptip trigger="hover" placement="right" transfer>
            <template #content>
              <img class="example-img m" src="@static/images/product/ex02.png"/>
            </template>
            <Icon type="ios-help-circle-outline" />
          </Poptip>
        </template>
        <upLoad :arr="formData.mobileCover" @upload="file => upLoadImg(file, 'mobileCover')" tip="注：尺寸:200*200px"> </upLoad>
        <Button type="primary" @click="chooseCover" ghost>选择底图生成封面</Button>
        <Button type="primary" @click="getCover('mobileCover')" ghost>随机生成封面</Button>
      </FormItem>
      <FormItem class="upload-item full" label="产品详情图" prop="detailImg">
        <template #label>
          <span>产品详情图</span>
          <Poptip trigger="hover" placement="right" transfer>
            <template #content>
              <img class="example-img m" src="@static/images/product/ex03.jpg"/>
            </template>
            <Icon type="ios-help-circle-outline" />
          </Poptip>
        </template>
        <upLoad :arr="formData.detailImg" @upload="file => upLoadImg(file, 'detailImg')" tip="支持JPG、JPEG或PNG格式，图宽为750px"> </upLoad>
      </FormItem>
      <FormItem class="upload-item full" label="产品视频" prop="video">
        <template #label>
          <span>产品视频</span>
          <Poptip trigger="hover" placement="right" transfer>
            <template #content>
              <img class="example-img m" src="@static/images/product/ex04.png"/>
            </template>
            <Icon type="ios-help-circle-outline" />
          </Poptip>
        </template>
        <upload-video :vUrl="formData.video" :iUrl="formData.videoImg" @upload="upLoadVideoCallback" tip="mp4格式，200M以内，宽高比16:9">
        </upload-video>
      </FormItem>
      <FormItem label="PC/APP列表标签" prop="titleLabel" class="full">
        <template #label>
          <span>PC/APP列表标签</span>
          <Poptip trigger="hover" transfer>
            <template #content>
              <img class="example-img" src="@static/images/product/ex05.png" />
              <br>
              <img class="example-img" src="@static/images/product/ex06.png" />
              <br>
              <img class="example-img" src="@static/images/product/ex07.png" />
            </template>
            <Icon type="ios-help-circle-outline" />
          </Poptip>
        </template>
        <add-tag v-model="formData.titleLabel" :maxlength="8" placeholder="请输入"></add-tag>
        <span>输入标签名称并<b>回车</b>新增标签，每个标签最多8个字</span>
      </FormItem>
      <FormItem label="PC端列表产品简介" prop="feature" class="full">
        <template #label>
          <span>PC端列表产品简介</span>
          <Poptip trigger="hover" transfer>
            <template #content>
              <img class="example-img" src="@static/images/product/ex08.png" />
            </template>
            <Icon type="ios-help-circle-outline" />
          </Poptip>
        </template>
        <Input type="textarea" v-model.trim="formData.feature" placeholder="最多60字" show-word-limit maxlength="60" />
      </FormItem>
      <FormItem label="产品保障责任" class="full">
        <template #label>
          <span>产品保障责任</span>
          <Poptip trigger="hover" transfer placement="right">
            <template #content>
              <img class="example-img m" src="@static/images/product/ex09.png" alt="示例图" srcset="" />
            </template>
            <Icon type="ios-help-circle-outline" />
          </Poptip>
        </template>
        <div class="guarantee-list">
          <div class="guarantee-item" v-for="(bean, i) in formData.guarantee" :key="bean.key">
            <Select v-model="bean.nameType" placeholder="请选择保障责任标题" clearable class="input" @on-change="guaranteeNameChange(bean)">
              <Option value="999"> 自定义 </Option>
              <Option v-for="(text,value) in dic.PRODUCT_GUARANTEE_TYPE" :key="value" :value="value" > {{text}} </Option>
            </Select>
            <Input v-if="bean.nameType == 999" v-model.trim="bean.name" class="input" placeholder="请输入保障责任标题" />
            <Button type="primary" @click="addGuarantee" v-if="formData.guarantee.length - 1 == i">新增</Button>
            <Button type="error" @click="delGuarantee(i)" v-if="formData.guarantee.length > 1">删除</Button>
            <editor v-model="bean.content" :toolbar="editorToolbar" :showFullScreen="false"></editor>
          </div>
        </div>
      </FormItem>
    </Form>

    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
    <!-- 选择头图 -->
    <bannerPopup ref="bannerPopup" @success="selectCover"> </bannerPopup>
    <!-- 选择底图 -->
    <coverPopup ref="coverPopup" @success="selectCover"> </coverPopup>
  </div>
</template>

<script>
import { uploadFile } from '@/api/httpList';
import confirmModal from '@/components/commons/confirmModal';
import addTag from '@/components/commons/addTag';
import bannerPopup from './bannerPopup';
import coverPopup from './coverPopup';
import editor from '@/components/commons/editor';
import upLoad from './upload';
import uploadVideo from '@/components/commons/uploadVideo';
export default {
  components: {
    confirmModal,
    uploadVideo,
    bannerPopup,
    coverPopup,
    upLoad,
    editor,
    addTag
  },
  props: {},
  data() {
    return {
      editorToolbar: ['bold', 'fontSize', 'indent'],
      formData: {},
      dic:{},//字典
    };
  },
  mounted() {
    this.dic = JSON.parse(localStorage.dic);
  },
  methods: {
    init(formData) {
      // 权益
      if (formData.guarantee) {
        const guarantee = JSON.parse(formData.guarantee);
        guarantee.forEach((item, i) => {
          item.key = i;
        });
        this.$set(formData, 'guarantee', guarantee);
      } else {
        this.$set(formData, 'guarantee', [{ key: Date.now() }]);
      }
      // 标签
      formData.titleLabel = formData.titleLabel || [];
      this.formData = formData;
      this.$forceUpdate();
      if(!formData.id) {
        this.getCover('mobileCover')
      }
      console.log(this.formData);
    },
    // 添加权益节点
    addGuarantee() {
      this.formData.guarantee.push({
        key: Date.now()
      });
    },
    // 删除权益节点
    delGuarantee(i) {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '请确认是否删除？'
        })
        .then(async () => {
          this.formData.guarantee.splice(i, 1);
        });
    },
    // 选择保障权益
    guaranteeNameChange(bean){
      if(bean.nameType == 999){
        this.$set(bean,'name','');
      }else{
        this.$set(bean,'name',this.dic.PRODUCT_GUARANTEE_TYPE[bean.nameType]);
      }
    },
    // 选择封面
    selectCover(data) {
      console.log('selectCover', data);
      if(data.key == 'headImg'){
        this.getBanner('headImg', data.url);
      }else{
        this.$set(this.formData, data.key, data.coverUrl);
        this.$refs.form.validateField(data.key);
      }
    },
    // 生成封面
    getCover(key) {
      this.$http({
        url: '/buz/productCoverLibrary/generate',
        type: 'POST',
        data: {
          filterUrl: this.formData.mobileCover
        }
      }).then(res => {
        this.$set(this.formData, key, res.data.coverUrl);
        this.$refs.form.validateField(key);
      });
    },
    // 生成banner
    getBanner(key, url){
      this.$http({
        url: '/buz/productArticle/combinPoster',
        type: 'POST',
        data: {
          companyCode: this.formData.companyCode,
          productName: this.formData.productName,
          imgaUrl: url,
        }
      }).then(res => {
        this.$set(this.formData, key, res.data);
        this.$refs.form.validateField(key);
      });
    },
    // 封面弹窗
    chooseCover() {
      this.$refs.coverPopup.open('mobileCover', this.formData.mobileCover);
    },
    // 头图弹窗
    bannerCover() {
      this.$refs.bannerPopup.open('headImg', this.formData.headImg);
    },
    //图片上传
    upLoadImg(file, key) {
      if (!file) {
        this.formData[key] = '';
        this.$refs.form.validateField(key);
        return;
      }
      let formData = new FormData();
      formData.append('file', file);
      uploadFile(formData).then(res => {
        this.formData[key] = res.data[0].path;
        this.$refs.form.validateField(key);
      });
    },
    //视频上传
    upLoadVideoCallback(fileData) {
      this.$set(this.formData, 'video', fileData.videoUrl);
      this.$set(this.formData, 'videoImg', fileData.imgUrl);
    },
    checkForm(data) {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (valid) {
            const productBase = data.productBase;
            if (productBase.titleLabel) {
              productBase.titleLabel = productBase.titleLabel.toString();
            }
            console.log('detailInfo', this.formData, productBase.guarantee);
            const guarantee = productBase.guarantee.filter(item => {
              delete item.key;
              return item.name;
            });
            productBase.guarantee = guarantee.length ? guarantee : '';
            resolve();
          } else {
            reject({ selTab: '3', selSecTab: 3 });
            this.$Message.warning('请正确填写表单');
          }
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .ivu-icon-ios-help-circle-outline {
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  margin-left: 4px;
}
/deep/ .ivu-icon-ios-alert-outline {
  font-size: 16px;
  font-weight: 600;
}
/deep/ .upload-item {
  margin-bottom: 30px;
  &.banner {
    .upload-wrap {
      width: 375px;
      height: 181px;
      .demo-upload-list {
        width: 100%;
        height: 100%;
        img {
          width: auto !important;
        }
      }
    }
  }

  .ivu-form-item-error-tip {
    top: unset;
    bottom: -30px;
  }

  .ivu-form-item-content {
    display: flex;
    align-items: center;

    .wrapper {
      flex-direction: column;
    }

    .ivu-btn {
      margin-left: 10px;
    }
  }
}
/deep/ .editor {
  margin-top: 15px;
  margin-bottom: 30px;
  .w-e-toolbar {
    z-index: 10 !important;
  }
  .w-e-text-container {
    height: 150px !important;
    z-index: 1 !important;
  }
  .w-e-text {
    min-height: 150px !important;
  }
}
.guarantee-list {
  .input {
    width: 300px;
    margin-right: 15px;
  }
}
.example-img {
  max-width: 1000px;
  max-height: 200px;
  &.m {
    max-height: 500px;
  }
}
.info-text {
  font-size: 12px;
  color: #515C6F;
  margin-bottom: 10px;
}
</style>